<template>
  <!-- Tabla -->
  <v-container>
    <vuescroll
      :ops="{
        bar: {
          background: '#bacfcec0',
          keepShow: true,
        },
      }"
    >
      <v-data-table
        :headers="tableHeaders"
        :items="tableList"
        class="elevation-0"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.assignment_agent`]="{ item }">
          <span>
            {{ item.assignment_agent == 1 ? item.registers__not_dialed_agent_count : item.registers__not_dialed_count }}
          </span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="goToRegister(item)">
              <v-icon>
                mdi-archive-edit-outline
              </v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </vuescroll>
  </v-container>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
export default {
  components: { vuescroll },
  // created() {
  //     this.getCampaigns();
  // },
  data() {
    return {
      isLoading: false,
      totalItems: 0,
      options: {},
      tableList: [],
      tableHeaders: [
        { text: "Nombre", value: "name", width: "20%" },
        { text: "Fecha de creado", value: "created_at", width: "15%" },
        { text: "Tipo", value: "type_campaign.name", width: "15%" },
        { text: "Cola", value: "queue.name", width: "15%" },
        { text: "Estado", value: "state", width: "15%" },
        {
          text: "Por marcar",
          value: "assignment_agent",
          width: "15%",
        },
        { text: "Acciones", value: "action", width: "15%" },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.getCampaigns();
      },
      deep: true,
    },
  },
  methods: {
    goToRegister(item) {
      this.$emit("goToRegister", item);
    },
    // Async
    async getCampaigns() {
      this.isLoading = true;
      const page = this.options.page || 1;
      const itemPerPage = this.options.itemsPerPage || 15;
      try {
        const { data } = await PbxHttpClient.get(`/campaign/campaign`, {
          params: { page, itemPerPage },
        });
        this.tableList = data.data;
        this.totalItems = data.total;
      } catch (err) {
        if (err.response.status === 401) {
          this.$snotify.error("Su sesion ha finalizado.", "Error");
          this.$store.dispatch("passport/RESET_AUTH");
          this.$router.push({ name: "login" });
          return;
        }
        // console.log(JSON.stringify(err));
      }
      this.isLoading = false;
    },
  },
};
</script>

<style></style>
